import React from 'react'
import jumbotron from 'react-bootstrap/Jumbotron';

export default function Jumbotron() {
    return (
        <div class="jumbotron text center ">
         Welcome to Bird Watcher-SQUACK edition. 

         Instructions:
         The following game is designed to test your ornolothological skills. Here you are in the midst of a strange html page. You suddenly are surrounded by birds. Can you ensure to not click one twice before reaching the number 12.
        
        </div>
    )
}
